import { normalizeFetchUsersResponse } from './utils/normalizers/user.normalizers'
import baseApi from './base.api'
import { onUpdateUserQueryStarted } from './utils/response-handlers/user.api.response-handlers'
import { createTagsForList, USER_TAG } from './utils/tags'

export const userApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchUsers: builder.query({
            query: ({ organizationOnly }) => ({
                url: `/users/`,
                method: 'GET',
                params: { organization_only: organizationOnly },
            }),
            transformResponse: normalizeFetchUsersResponse,
            providesTags: result => createTagsForList(result.items, USER_TAG),
        }),
        inviteUser: builder.mutation({
            query: ({ email, name, organizationId, type, roles }) => ({
                url: `/users/invite`,
                method: 'POST',
                data: { email, name, organization_id: organizationId, type, roles },
            }),
            invalidatesTags: [{ type: USER_TAG, id: 'LIST' }],
        }),
        reinviteUser: builder.mutation({
            query: ({ userId }) => ({
                url: `/users/${userId}/reinvite`,
                method: 'POST',
            }),
            invalidatesTags: [{ type: USER_TAG, id: 'LIST' }],
        }),
        setupUserAccount: builder.mutation({
            query: ({ token, password, name }) => ({
                url: `/auth/activate-account`,
                method: 'POST',
                data: { token, password, name },
            }),
        }),
        updateUser: builder.mutation({
            query: ({ id, name, organizationId, roles, type, status }) => ({
                url: `/users/${id}`,
                method: 'PATCH',
                data: { name, organization_id: organizationId, roles, type, status },
            }),
            onQueryStarted: onUpdateUserQueryStarted,
            invalidatesTags: (result, error, { id }) => [{ type: USER_TAG, id }],
        }),
        updateThresholds: builder.mutation({
            query: ({ low, medium, high }) => ({
                url: `/users/update-thresholds`,
                method: 'PATCH',
                data: {
                    low_threshold: low,
                    high_threshold: medium,
                    very_high_threshold: high,
                },
            }),
        }),
    }),
})

export const {
    useFetchUsersQuery,
    useInviteUserMutation,
    useReinviteUserMutation,
    useSetupUserAccountMutation,
    useUpdateUserMutation,
    useUpdateThresholdsMutation,
} = userApi
